import { VariantImage } from '../../api/models/variant-image';
import { VariantImageType } from '../../api/models/variant-image-type';

const useFilterAttachmentsSsr = (
    type: VariantImageType,
    attachments?: VariantImage[]
): VariantImage[] => {
    return (
        attachments?.filter?.((attachment) => attachment.type === type) ?? []
    );
};

export default useFilterAttachmentsSsr;
